/**
 * Pseudo principal + bulle « +N » listant les autres joueurs (infobulle structurée).
 */

import DiffereStatsHoverTip from './DiffereStatsHoverTip';

export default function DiffereStatsPseudoPlusBubble({
  pseudos,
  primary,
  primaryLabel,
}: {
  pseudos: string[];
  /** Pseudo technique à exclure de la bulle +N (sinon premier de la liste). */
  primary?: string;
  /** Libellé affiché pour le joueur principal (ex. pseudoDisplay). */
  primaryLabel?: string;
}) {
  const list = pseudos.length > 0 ? pseudos : (primary ? [primary] : []);
  if (list.length === 0) return null;

  const headKey = primary && list.includes(primary) ? primary : list[0]!;
  const headLabel = headKey === primary && primaryLabel ? primaryLabel : headKey;
  const others = list.filter(p => p !== headKey);

  return (
    <span className="differe-stats-pseudo-plus">
      <span className="differe-stats-pseudo-plus-main">{headLabel}</span>
      {others.length > 0 && (
        <DiffereStatsHoverTip
          title={`${others.length} autre${others.length > 1 ? 's' : ''} joueur${others.length > 1 ? 's' : ''}`}
          body={(
            <ul className="differe-stats-hover-tip-list">
              {others.map(p => <li key={p}>{p}</li>)}
            </ul>
          )}
        >
          <span className="differe-stats-pseudo-plus-bubble">+{others.length}</span>
        </DiffereStatsHoverTip>
      )}
    </span>
  );
}
